var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c("h2", [
            _vm._v(
              "Winfakt " + _vm._s(_vm.$ct("common.tiers." + _vm.plan.tier))
            ),
          ]),
          _vm.showRecuringPrice && !_vm.showOneTimePrice
            ? _c("app-recuring-price", {
                attrs: {
                  pricing: _vm.price.recuringPrice,
                  "hide-period": _vm.renew,
                },
                on: {
                  "toggle-interval": function ($event) {
                    return _vm.toggleInterval()
                  },
                },
              })
            : _vm._e(),
          _vm.showOneTimePrice
            ? [
                _vm.showRecuringPrice
                  ? _c("app-pay-row", {
                      attrs: { label: _vm.$ct("one-time-costs") },
                    })
                  : _vm._e(),
                _c("app-one-off-price", {
                  attrs: { pricing: _vm.price.oneTimePrice },
                }),
              ]
            : _vm._e(),
          _vm.mandate
            ? _c("div", [
                _c(
                  "p",
                  { staticClass: "pay-row" },
                  [
                    _vm._v(" " + _vm._s(_vm.$ct("labels.method")) + " "),
                    _c("w-spacer"),
                    _vm._v(" " + _vm._s(_vm.mandate.formatCardLabel()) + " "),
                  ],
                  1
                ),
                _c(
                  "p",
                  { staticClass: "pay-row-sub" },
                  [
                    _c("w-spacer"),
                    _vm._v(" " + _vm._s(_vm.mandate.details.cardNumber) + " "),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.discountCode &&
          (_vm.price.recuringPrice.discount || _vm.price.oneTimePrice.discount)
            ? _c(
                "w-row",
                { style: { marginTop: "20px" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$ct("discount-applied", { code: _vm.discountCode })
                      ) +
                      " "
                  ),
                  _c(
                    "w-link",
                    {
                      on: {
                        click: function ($event) {
                          ;(_vm.discountCodeInput = ""), _vm.checkDiscountCode()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("remove-discount")))]
                  ),
                  _vm.showRecuringPrice
                    ? _c("div", { staticClass: "infobox mt" }, [
                        _vm._v(" " + _vm._s(_vm.nextPayment) + " "),
                        _vm.plan.paymentFrequency == 0
                          ? _c(
                              "div",
                              { staticClass: "mts" },
                              [
                                _c(
                                  "w-link",
                                  {
                                    staticClass: "mt",
                                    style: {
                                      textDecoration: "underline",
                                      fontWeight: "bold",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleYear()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$ct("discount-year-switch")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.discountCodeAllowed &&
          (!_vm.discountCode ||
            (!_vm.price.recuringPrice.discount &&
              !_vm.price.oneTimePrice.discount))
            ? _c(
                "w-row",
                { style: { marginTop: "20px" }, attrs: { "no-margin": "" } },
                [
                  _c("w-input", {
                    staticClass: "mr",
                    style: { flexGrow: 1 },
                    attrs: {
                      value: _vm.discountCode,
                      fancy: "",
                      label: _vm.$ct("discount-code"),
                    },
                    on: {
                      input: function ($event) {
                        _vm.discountCodeInput = $event
                      },
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("apply-code"),
                          expression: "$ct('apply-code')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.checkDiscountCode()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "check" } })],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-button",
            {
              staticClass: "mt",
              style: { width: "100%", marginTop: "40px" },
              attrs: { green: "" },
              on: {
                click: function ($event) {
                  return _vm.createSubscription()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.awaitingPayment,
            callback: function ($$v) {
              _vm.awaitingPayment = $$v
            },
            expression: "awaitingPayment",
          },
        },
        [_vm.awaitingPayment ? _c("app-awaiting-payment") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }